import React from 'react';
import PropTypes from 'prop-types';
import ClipLoader from 'react-spinners/ClipLoader';
import { FormCheck } from 'react-bootstrap';
import { bytesToSize } from '../../../util/form';
import config from '../../../config';

const FileListItem = React.forwardRef(
  (
    {
      disableDrag = false,
      file = {},
      icon,
      canDelete = true,
      onClick = () => {},
      onDelete = () => {},
      onSelect = () => {},
      ...rest
    },
    ref
  ) => {
    const handleClick = event => onClick(event, file);

    const handleRemoveClick = event => {
      event.stopPropagation();
      onDelete(file);
    };

    const getFileName = () => {
      const viewableFileName = file.originalname || file.filename || '';

      if (!viewableFileName && file.uploading) {
        return 'Uploading...';
      }

      return viewableFileName.length > 75 ? `${viewableFileName.substring(0, 35)}...` : viewableFileName;
    };

    const handleCheckChange = () => {
      onSelect(file.id);
    };

    return (
      <div className="file-list-item" ref={ref} key={file.id || file.filename} onClick={handleClick} {...rest}>
        {!disableDrag && (
          <div className="drag-handler mr-2">
            <i className="fas fa-grip-vertical" />
          </div>
        )}
        <FormCheck className="pl-1">
          <FormCheck.Input type="checkbox" onChange={handleCheckChange} checked={file.selected} />
        </FormCheck>
        <div className="file-icon mr-2">
          {file.uploading ? <ClipLoader size={14} color="#2196F3" /> : <img src={config.publicUrl(`img/${icon}`)} />}
        </div>
        <div className="file-name">{getFileName()}</div>
        <div className="mr-2 badge badge-light font-weight-normal">{new Date(file.createdAt).toLocaleString()}</div>
        <div className="file-size mr-2">{file.size && `[${bytesToSize(file.size)}]`}</div>
        {canDelete && (
          <div className="remove-button" onClick={handleRemoveClick}>
            <i className="fal fa-times close-button" />
          </div>
        )}
      </div>
    );
  }
);

FileListItem.propTypes = {
  canDelete: PropTypes.bool,
  file: PropTypes.object,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  onDelete: PropTypes.func,
};

export default FileListItem;
